import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  getSolutionsBreadcrumbs,
  PageType,
  SolutionsHeroType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionHero } from 'routes/Solutions/components/SolutionHero'
import { SolutionHIL } from 'routes/Solutions/components/SolutionHIL'
import { SolutionHowItWorks } from 'routes/Solutions/components/SolutionHowItWorks'
import { SolutionScenarios } from 'routes/Solutions/components/SolutionScenarios'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import AppsGrid from '../components/SolutionHIL/components/AppsGrid'
import MonitorStatus from '../components/SolutionHIL/components/MonitorStatus'
import PushDataTable from './PushDataTable'
import pushDataMob1x from './push-data-mob@1x.avif'
import pushDataMob2x from './push-data-mob@2x.avif'
import pushDataDesk1x from './push-data-desk@1x.avif'
import pushDataDesk2x from './push-data-desk@2x.avif'
import fieldMappings1x from 'routes/Solutions/components/SolutionHIL/components/FieldMappings/field-mappings@1x.avif'
import fieldMappings2x from 'routes/Solutions/components/SolutionHIL/components/FieldMappings/field-mappings@2x.avif'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'Push Data to External Apps',
  href: LINKS.SOLUTIONS.PUSH_DATA_TO_EXTERNAL_APPS.URL,
  tag: LINKS.SOLUTIONS.PUSH_DATA_TO_EXTERNAL_APPS.TAG,
  imageSrc: `${pushDataDesk1x.src}`,
  srcSet: `${pushDataDesk1x.src} 1x, ${pushDataDesk2x.src} 2x`,
  description:
    'Let your users navigate data in external app: files, people, companies, etc.',
}

const pageHeroData: SolutionsHeroType = {
  title: 'Push data to external apps',
  subtitle:
    'Let your users sync data your app generates to external apps and associate it with existing objects.',
  imageWidth: '308',
  imageHeight: '781',
  mobile1x: pushDataMob1x,
  mobile2x: pushDataMob2x,
  desktop1x: pushDataDesk1x,
  desktop2x: pushDataDesk2x,
}

export default function PushDataToExternalApp({
  scenariosByTag,
}: {
  scenariosByTag: ScenarioTemplateCompact[]
}) {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <SolutionHero {...pageHeroData} />
        <SolutionHIL
          titles={[
            { text: 'Select another SaaS to import data from' },
            { text: 'Configure field mappings', optional: true },
            { text: 'Push selected data records or configure auto-push' },
            { text: 'Monitor pushes and react to errors', h64: true },
          ]}
        >
          <AppsGrid />
          <img
            srcSet={`${fieldMappings1x.src} 1x, ${fieldMappings2x.src} 2x`}
            src={fieldMappings1x.src}
            alt='Configure field mappings'
            width={522}
            height={314}
            loading='lazy'
          />
          <PushDataTable />
          <MonitorStatus />
        </SolutionHIL>
        <SolutionHowItWorks
          guideLink='https://docs.integration.app/docs/pushing-data-to-external-apps#/'
          steps={[
            'Select apps you want your customers to push data to',
            'Configure data push flows',
            "Build UI to connect your customer's account in an external app",
            'Run the push flow(s) via API requests or events in your app',
          ]}
        />
        <SolutionScenarios
          scenarios={scenariosByTag}
          scenariosTag={pageData.tag}
        />
        <SolutionCompanies />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
